module.exports = __webpack_public_path__ + "img/301-1dd134.png";